import { render, staticRenderFns } from "./b-menu-view.vue?vue&type=template&id=2efa000f&scoped=true&"
import script from "./b-menu-view.vue?vue&type=script&lang=js&"
export * from "./b-menu-view.vue?vue&type=script&lang=js&"
import style0 from "./b-menu-view.vue?vue&type=style&index=0&id=2efa000f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efa000f",
  null
  
)

export default component.exports